import { ShimmerText } from 'module/ui/components/atoms/shimmer-text';
import { faMagic } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  Label,
  Title as TitleComponent,
} from '../organisms/document-editor/extensions/ask-ai/ui/command-processor/section-ui/title';

const LoadingTitle = styled(TitleComponent)`
  margin-top: var(--spacing-03);
  gap: var(--spacing-03);
`;

export const LoaderStreamingComponent = () => {
  return (
    <LoadingTitle>
      <FontAwesomeIcon icon={faMagic} size="sm" />
      <Label>
        <ShimmerText loading={true}>
          <FormattedMessage id="thinking" />
        </ShimmerText>
      </Label>
    </LoadingTitle>
  );
};
